import { Link } from "react-router-dom";
import { itemPath, tileVariantOf } from "../../../utilities/item-kinds";
import FramedImage from "../../../components/FramedImage/FramedImage";
import { issueYear } from "../../../utilities/dates";
import { thumbUrl } from "../../../utilities/image-urls";

// Four variants: landscape/portrait orientation (the grid decides the
// span) crossed with label/image-only. The markup is identical — only
// the label overlay and its year suffix vary.
export default function CoverTile({ item }) {
  const variant = tileVariantOf(item);
  const showLabel = !variant.endsWith("-image");
  const isLandscape = variant.startsWith("landscape");

  return (
    <Link
      to={itemPath(item)}
      state={{ fromFeed: true }}
      className="group relative block h-full rounded-md overflow-hidden bg-cream border border-ink/5"
    >
      <FramedImage
        src={item.image}
        thumbSrc={thumbUrl(item.image)}
        alt={item.subject || "First-day cover"}
        framing={item.framing?.tile}
        hoverZoom
        loading="lazy"
      />
      {showLabel && (
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/70 to-transparent px-4 pt-8 pb-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/70 mb-1">
            First-day cover
          </p>
          <p className="font-serif text-sm text-white leading-snug line-clamp-2">
            {item.subject || item.catalogue_id}
            {isLandscape && item.year && (
              <span className="font-mono text-xs text-white/60">
                {" "}
                — {issueYear(item.year)}
              </span>
            )}
          </p>
        </div>
      )}
    </Link>
  );
}
